export default "__VITE_ASSET__D5sb1SFo__"